import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/regencies'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(regency) {
    return http.post(`${resource}`, regency, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(regency, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, regency, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
